export const SELECT_OPTION_FROM_DROPDOWN =
  'Please enter an option from the dropdown';
